import React, { Component } from 'react'
import { Router, Route, browserHistory, IndexRoute } from 'react-router'

import Header from './components/header'
import Landing from './components/landing'
import Features from './components/features'
import Waitlist from './components/waitlist'

require('./stylesheets/main.scss')

class Container extends Component {

  render() {
    const childrenWithProps = React.Children.map(this.props.children,
      (child) => React.cloneElement(child, ...this.props)
    )

    return (
      <div className="container">
        <Header {...this.props} />
        <main>
          { childrenWithProps }
        </main>
      </div>
    )
  }
}

class App extends Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Route path="/" component={Container}>
          <IndexRoute component={Landing} />
          <Route title="Features" path="/features" exact component={Features} />
          <Route title="Waitlist" path="/waitlist"  component={Waitlist} />
        </Route>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js